
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HotspotSlideFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HotspotSlide"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HotspotSlideLightFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentItem"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandOrDistributorLogo"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentItemLightFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":226}};
    doc.loc.source = {"body":"#import \"./content-item-light.gql\"\n#import \"./hotspot-slide-light.gql\"\n\nfragment HotspotSlideFields on HotspotSlide {\n  ...HotspotSlideLightFields\n  contentItem {\n    brandOrDistributorLogo\n    ...ContentItemLightFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./content-item-light.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./hotspot-slide-light.gql").definitions));


      module.exports = doc;
    
